import { SpinnerContainer } from "./spinner.styles"

const Spinner = () => {
  return <SpinnerContainer></SpinnerContainer>
}

export default Spinner
